<template>
  <el-row class="progress-bar-mobile">
    <div @click="$emit('gotoday')">
      <el-row class="info">
        <el-col :span="14" class="date">
          <b>{{ getDate() }}</b>
          <span v-if="day.status === 1" class="closed"> (день закрыт) </span>
        </el-col>
        <el-col :span="10" class="ta-r">
          <b>
            <span class="blue">{{ getPercentages.notServedCount }} / </span>
            <span class="green">{{ getPercentages.approvedCount }} / </span>
            <span class="gray">{{ getPercentages.requestCount }} / </span>
            <span>{{ getPercentages.dayCarsCount }}</span>
            <span v-if="getPercentages.rest < 0" class="red">
              {{ getPercentages.rest }}
            </span>
          </b>
        </el-col>
      </el-row>
      <zerno-progress-bar :percentages="getPercentages" :mobile="true" />
    </div>
  </el-row>
</template>

<script>
import { checkDate } from '@/helpers/functions'
import ZernoProgressBar from '@/components/Shared/ZernoProgressBar'

export default {
  name: 'ProgresBarMobile',
  components: { ZernoProgressBar },
  props: {
    day: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      current: {},
      dialog_bid_points: false,
      currentPage: 1,
    }
  },
  computed: {
    getPercentages() {
      const {
        cars_count: dayCarsCount,
        responses_count_not_served: notServedCount,
        responses_count_approved: approvedCount,
        response_requests_count: requestCount,
      } = this.day
      const rest = approvedCount + notServedCount + requestCount - dayCarsCount

      return { dayCarsCount, notServedCount, approvedCount, requestCount, rest }
    },
  },
  methods: {
    getDate() {
      return checkDate(this.day.load_date)
    },
  },
}
</script>

<style lang="sass">
.progress-bar-mobile
  margin: 20px 0 30px
  .info
    margin-bottom: 5px
    .date b
      text-transform: capitalize
    .closed
      color: #ff0000
      margin-left: 5px
    .blue
      color: #409eff
    .green
      color: #5daf34
    .gray
      color: #7c8185
    .red
      margin-left: 10px
      color: #ff0000
</style>
